// Small, dependency-free "add to calendar" helpers for a single event.
// Covers Google, Outlook (365 web deeplink) and an .ics download that desktop
// Outlook and Apple Calendar both open.

const pad = (n) => String(n).padStart(2, "0");

// 20260705T193000Z (UTC basic format) - used by Google and ICS.
function toBasicUtc(value) {
	const d = new Date(value);
	return (
		`${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}` +
		`T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`
	);
}

export function googleCalendarUrl({ title, details, start, end }) {
	const params = new URLSearchParams({
		action: "TEMPLATE",
		text: title,
		details: details || "",
		dates: `${toBasicUtc(start)}/${toBasicUtc(end)}`,
	});
	return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function outlookCalendarUrl({ title, details, start, end }) {
	const params = new URLSearchParams({
		path: "/calendar/action/compose",
		rru: "addevent",
		subject: title,
		body: details || "",
		startdt: new Date(start).toISOString(),
		enddt: new Date(end).toISOString(),
	});
	return `https://outlook.office.com/calendar/0/deeplink/compose?${params.toString()}`;
}

function buildIcs({ title, details, start, end }) {
	const escape = (s) => (s || "").replace(/([,;\\])/g, "\\$1").replace(/\n/g, "\\n");
	return [
		"BEGIN:VCALENDAR",
		"VERSION:2.0",
		"PRODID:-//EMI3//Maintenance//EN",
		"BEGIN:VEVENT",
		`UID:${toBasicUtc(start)}-emi3-maintenance`,
		`DTSTAMP:${toBasicUtc(new Date())}`,
		`DTSTART:${toBasicUtc(start)}`,
		`DTEND:${toBasicUtc(end)}`,
		`SUMMARY:${escape(title)}`,
		`DESCRIPTION:${escape(details)}`,
		"END:VEVENT",
		"END:VCALENDAR",
	].join("\r\n");
}

export function downloadIcs(event) {
	const blob = new Blob([buildIcs(event)], {
		type: "text/calendar;charset=utf-8",
	});
	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = "emi3-maintenance.ics";
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(url);
}
